import { RefObject, useEffect, useState } from 'react';

export const useVisibility = (ref: RefObject<Element>, rootMargin = '150px') => {
  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin }
    );

    observer.observe(node);

    return () => observer.unobserve(node);
  }, [ref, rootMargin]);

  return isVisible;
};
